<!--
 * @Author: 王枫叶
 * @Date: 2020-10-21 16:53:48
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-10-29 19:16:22
-->
<template>
  <div class="louFeng-box"> 
     <h3 style="text-align:center ;"> 城市和折扣配置</h3>
    <div v-for="(item, i) in tableData" :key="i" class="lf_cfg">
      <div class="lf_cfg_content">
        <div>
          热门城市:<span>{{ item.hotCity }}</span>
          <el-button  size="small" @click="action_city(item.hotCity)" style="">修改【热门城市】</el-button>
        </div>
        <div>
          折扣率:<span>{{ item.discountRate + ' %' }}</span>
        <el-button  size="small" @click="action_dr(item.discountRate)" style="">修改【折扣率】</el-button>     
        </div>
      </div>
     </div>
    <!-- 编辑热门城市 -->
    <city-cfg ref="cityCfg" @handlerChannelList="getLoufCfgList"></city-cfg>
    <!-- 编辑折扣率 -->
    <dr-cfg ref="drCfg" @handlerChannelList="getLoufCfgList"></dr-cfg>    
  </div>
</template>

<script>
import API from '@/api'
import CityCfg from './components/cityCfg'
import DrCfg from './components/drCfg'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      // 列表数据
      tableData: [],
      pageData: {},
      total: 0,
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,
    }
  },
  components: {
    CityCfg,
    DrCfg
  },
  created() {
    this.getLoufCfgList()
  },
  methods: {
    // 请求楼凤信息列表
    getLoufCfgList(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getLoufCfgList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = [res.data]
            this.pageData = res.data
          } else {
            this.tableData = []
            this.pageData = {}
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    //编辑热门城市
    action_city(hotCity) {
      this.$refs.cityCfg.open(hotCity)
    },
    //编辑热门城市
    action_dr(discountRate) {
      this.$refs.drCfg.open(discountRate)
    },    
  },
}
</script>

<style lang="scss">
.lf_cfg {
  .lf_cfg_content {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    div {
      margin-bottom: 10px;
      span {
        color: cadetblue;
      }
      .el-button {
        background:	rgba(230,55,101,.8) ;
        margin-left: 20px;
        span {
          color: #ffffff;
        }
      }
    }
    .btn_style {
      padding: 4px 8px;
      color: #000000;
      background: #327720;
      border: 1px solid #999999;
      border-radius: 20px;
    }
  }
}
</style>
